import { ADD_ACTIVE_EXPENSE_TAG_BUCKETS, ADD_ACTIVE_TEAM_FIELD_BUCKETS_WITH_ACTIVE_TAGS } from '@Actions/expenseBucketsActions';
export const defaultState = {
    activeExpenseBuckets: [],
    activeTeamFieldBucketsWithActiveTags: []
};
export function expenseBucketsReducer(state = defaultState, action) {
    switch (action.type) {
        case ADD_ACTIVE_EXPENSE_TAG_BUCKETS: {
            return Object.assign(Object.assign({}, state), { activeExpenseBuckets: action.payload });
        }
        case ADD_ACTIVE_TEAM_FIELD_BUCKETS_WITH_ACTIVE_TAGS: {
            return Object.assign(Object.assign({}, state), { activeTeamFieldBucketsWithActiveTags: action.payload });
        }
        default:
            return state;
    }
}
